/*
 * Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Injectable } from "@angular/core";

@Injectable()
export class BciLayoutIntl {
  /* A label for logout button*/
  logout = "Logout";

  /* An alternative text for the Bosch logo */
  inventedLogoAlt = "Bosch Invented For Life Logo";
}

export const BCI_LAYOUT_INTL_PROVIDER = {
  provide: BciLayoutIntl,
  useClass: BciLayoutIntl
};
